// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4421d26","667":"51ff55f6"}[chunkId] + ".chunk.js";
};